<template>
  <v-container :fluid="true" class="bg-light-beige ma-0 pa-0">
    <div class="page__title">
      Создание учетной записи
    </div>
    <div class="page__subtitle">
      Для продолжения работы в системе выполните регистрацию
    </div>
    <div class="text_field__container">
      <v-form
          ref="form"
          class="text_field__container"
      >
        <v-text-field
            class="text__field"
            color="#3254B9"
            base-color="#313743"
            variant="outlined"
            name="login"
            :rules="[rules.email]"
            v-model="data.email"
            :loading="loading"
            :error="hasError('email')"
            :error-messages="getError('email')"
        >
          <template v-slot:label>
            <div class="label__text">
              Электронная почта
            </div>
          </template>
        </v-text-field>
        <v-text-field
            id="password"
            v-model="data.password"
            :append-inner-icon="show ? 'visibility_off' : 'visibility'"
            :type="show ? 'text' : 'password'"
            :title="passwordMsg"
            :rules="[rules.required, rules.passStr, rules.symbControl]"
            :loading="loading"
            @click:appendInner="show = !show"
            class="text__field"
            color="#3254B9"
            base-color="#313743"
            variant="outlined"
            :error="hasError('password')"
            :error-messages="getError('password')"
        >
          <template v-slot:label>
            <div class="label__text">
              Пароль
            </div>
          </template>
        </v-text-field>
        <v-text-field
            id="password"
            v-model="data.repeat"
            :append-inner-icon="approve_show ? 'visibility_off' : 'visibility'"
            :type="approve_show ? 'text' : 'password'"
            :rules="[rules.repeatPass]"
            :loading="loading"
            @click:appendInner="approve_show = !approve_show"
            @keyup.enter="sendCreateUser"
            class="text__field"
            color="#3254B9"
            base-color="#313743"
            variant="outlined"
            :error="hasError('repeat')"
            :error-messages="getError('repeat')"
        >
          <template v-slot:label>
            <div class="label__text">
              Подтверждение пароля
            </div>
          </template>
        </v-text-field>
      </v-form>
<!--      <div class="text__field text-black">-->
<!--        <v-alert-->
<!--            class="error_alert"-->
<!--            v-if="error"-->
<!--            :value="true"-->
<!--            rounded="lg"-->
<!--            outline-->
<!--            color="#8f0808"-->
<!--            icon=""-->
<!--            variant="outlined"-->
<!--        >-->
<!--          {{ error.error }}-->
<!--        </v-alert>-->
<!--      </div>-->
      <div class="btn__next back" @click="$router.push({name: names.MAIN})">
        <span class="btn__next_text">
          Назад
        </span>
      </div>
      <v-btn
          class="btn__next"
          elevation="0"
          :loading="loading"
          @click="validate"
      >
        <span class="btn__next_text">
          Отправить
        </span>
      </v-btn>
    </div>
  </v-container>
</template>

<script>
import { defineComponent } from 'vue'
import names from "@/modules/core/routers/names"
import pa_names from "@/modules/personal_account/routers/names"
import { mapActions, mapGetters } from "vuex"
import FormErrorsMixin from "@/mixins/FormErrorsMixin"

export default defineComponent({
  name: "RegistrationUser",
  mixins: [FormErrorsMixin],
  data () {
    return {
      loading: false,
      valid: false,
      show: false,
      approve_show: false,
      error: null,
      data: {
        email: null,
        password: null,
        repeat: null
      },
      passwordMsg: "Пароль должен иметь размер не менее 8 символов, содержать латинские буквы нижнего, верхнего регистров, а так же цифру. Может содержать только символы от a до Z, цифры от 0 до 9",
      rules: {
        required: value => !!value || 'Введите пароль',
        symbControl: value => this.symbControl(value) || 'Некорректный ввод',
        passStr: value => {
          const pattern = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])[0-9a-zA-Z!#$%&'*+\-.:<=>?@^_`|~]{8,}$/
          return pattern.test(value) || this.passwordMsg
        },
        repeatPass: value => {
          if (value !== null) {
            return this.data.password === value || 'Пароли не совпадают'
          } else {
            return 'Подтвердите ввод пароля'
          }
        },
        email: value => {
          if (value !== null) {
            const pattern = /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,9})+$/
            return pattern.test(value) || 'Некорректный ввод'
          } else {
            return 'Введите адрес Вашей электронной почты'
          }
        },
      }
    }
  },
  watch: {
    data: {
      handler: function () {
        this.errors = {
          fields: {},
          non: []
        }
      },
      deep: true
    }
  },
  computed: {
    pa_names () {
      return pa_names
    },
    names () {
      return names
    },
    ...mapGetters({
      isAuthenticated: 'auth/isAuthenticated',
    })
  },
  methods: {
    ...mapActions({
      createUser: 'personal_account/users/createUser',
    }),
    endRedirect () {
      this.$router.push({ name: names.CREATE_USER.INFO })
    },
    async validate () {
      const { valid } = await this.$refs.form.validate()

      if (valid) {
        this.sendCreateUser()
      }
    },
    sendCreateUser: function () {
      this.loading = true
      this.error = null
      this.createUser(
        {
          data: this.data,
          finalizer: () => {
            this.loading = false
            this.error = null
            this.endRedirect()
          },
          catcher: (error) => {
            this.loading = false
            if (error.email[0] === "user с таким email уже существует.") {
              error.email[0] = "Пользователь с таким адресом электронной почты уже существует."
            } else if (error.email[0] === "Вы уже начали процесс регистрации с этой почтовой учетной записью") {
              this.$router.push({ name: names.EMAIL_RESEND.PAGE, query: { email: this.data.email, type: 'registration' } })
            }
            this.mapErrors(error)
          }
        }
      )
    },
    symbControl: function (value) {
      if (value === null) {
        return true
      }
      return !(value.includes(' ') || value.includes('\n'))
    }
  },
  created () {
    if (this.isAuthenticated) { this.endRedirect() }
  },
})
</script>

<style scoped lang="scss">
.page__title {
  margin-top: 30px;
  margin-bottom: 30px;
  font-style: normal;
  font-weight: 800;
  font-size: 75px;
  line-height: 84px;
  text-align: center;

  color: #3254B9;
}

.page__subtitle {
  margin-bottom: 50px;
  font-style: normal;
  font-weight: 600;
  font-size: 40px;
  line-height: 51px;
  text-align: center;

  color: #313743;
}

.text_field__container {
  margin: 0 auto;
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  width: 500px;
}

.text__field {
  margin: 0 auto 20px;
  width: 100%;
}

.v-field__field:hover {
  .label__text {
    color: black;
  }
}

.label__text {
  font-style: normal;
  font-weight: 500;
  font-size: 24px;
  line-height: 29px;
  text-align: center;

  color: #313743;
}

.btn__next {
  cursor: pointer;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  align-self: end;
  margin-bottom: 40px;
  width: 200px;
  height: 80px;
  border: 2px solid #3254B9;
  background-color: #3254B9;
  border-radius: 10px;

  &.back {
    margin-right: 50px;
    background-color: transparent;

    .btn__next_text {
      color: #3254B9;
    }

    &:hover {
      background-color: #3254B9;

      .btn__next_text {
        color: #FFFFFF;
      }
    }
  }

  &:hover {
    background-color: transparent;

    .btn__next_text {
      color: #3254B9;
    }
  }
}

.btn__next_text {
  font-style: normal;
  font-weight: 700;
  font-size: 24px;
  line-height: 29px;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  color: #FFFFFF;
}

.error_alert {
  border-radius: 10px;
  font-style: normal;
  font-weight: 700;
  font-size: 24px;
  line-height: 29px;
  color: #8f0808;
  margin-bottom: 20px;
}

@media screen and (max-width: 1920px) {
  .page__title {
    font-size: 65px;
    line-height: 74px;
  }

  .page__subtitle {
    margin-bottom: 40px;
    font-size: 30px;
    line-height: 41px;
  }

  .text__field {
    margin-bottom: 10px;
  }

  .btn__next {
    height: 70px;
  }
}

@media screen and (max-width: 1279px) {
  .page__title {
    font-size: 50px;
    line-height: 57px;
    padding: 0 40px;
  }

  .page__subtitle {
    font-size: 24px;
    line-height: 31px;
    padding: 0 40px;
  }
}

@media screen and (max-width: 768px) {
  .page__title {
    font-size: 30px;
    line-height: 37px;
    padding: 0 20px;
  }

  .page__subtitle {
    margin-bottom: 40px;
    font-size: 18px;
    line-height: 22px;
    padding: 0 20px;
  }

  .text_field__container {
    width: 400px;
  }

  .label__text {
    font-size: 16px;
    line-height: 20px;
  }

  .btn__next {
    margin: 0 10px 20px;
    height: 55px;

    &.back {
      margin-right: 10px;
    }
  }

  .btn__next_text {
    font-size: 16px;
    line-height: 20px;
  }
}

@media screen and (max-width: 600px) {
  .text_field__container {
    width: 270px;
  }

  .text__field {
    margin-bottom: 8px;
  }
}
</style>
